import React, { useState } from "react";
import { Users, Briefcase, ArrowRight, Star, Clock, Shield, Sparkles, Award } from "lucide-react";
import BookingModal from "../BookingModal";
import "./Pricing.css";

import sedanImg from "../../assets/new/Gallery3.jpeg";
import ertigaImg from "../../assets/new/Gallery1.jpeg";
import sedanImg2 from "../../assets/new/Gallery7.jpeg";
import innovaImg from "../../assets/new/Gallery4.jpeg";
import innovaCrystaImg from "../../assets/new/Gallery9.jpeg";
import urbaniyaImg from "../../assets/new/Gallery5.jpeg";

const vehicles = [
  {
    id: 1,
    img: sedanImg,
    name: "Sedan",
    rate: "₹10 / km",
    model: "Dzire, Etios or Similar",
    seats: "4 Seater",
    bags: "3 Bags",
    ac: "AC",
    popular: false,
  },
  {
    id: 2,
    img: ertigaImg,
    name: "Ertiga",
    rate: "₹13 / km",
    model: "Ertiga, Etios or Similar",
    seats: "7 Seater",
    bags: "3 Bags",
    ac: "AC",
    popular: true,
  },
  {
    id: 3,
    img: sedanImg2,
    name: "Sedan",
    rate: "₹10 / km",
    model: "Dzire, Etios or Similar",
    seats: "4 Seater",
    bags: "3 Bags",
    ac: "AC",
    popular: false,
  },
  {
    id: 4,
    img: innovaImg,
    name: "Innova",
    rate: "₹15 / km",
    model: "Innova, Etios or Similar",
    seats: "7 Seater",
    bags: "3 Bags",
    ac: "AC",
    popular: false,
  },
  {
    id: 5,
    img: innovaCrystaImg,
    name: "Innova Crysta",
    rate: "₹18 / km",
    model: "Innova Crysta, Etios or Similar",
    seats: "7 Seater",
    bags: "3 Bags",
    ac: "AC",
    popular: false,
  },
  {
    id: 6,
    img: urbaniyaImg,
    name: "Urbaniya",
    rate: "₹35 / km",
    model: "Urbaniya, Etios or Similar",
    seats: "15 Seater",
    bags: "3 Bags",
    ac: "AC",
    popular: false,
  },
];

const Pricing = () => {
  const [showPopup, setShowPopup] = useState(false);

  const handleBookNow = () => {
    setShowPopup(true);
    document.body.style.overflow = "hidden";
  };

  const closePopup = () => {
    setShowPopup(false);
    document.body.style.overflow = "auto";
  };

  return (
    <>
      <section className="pricing" id="pricing">
        {/* Background Decor */}
        <div className="pricing-bg-glow-1"></div>
        <div className="pricing-bg-glow-2"></div>
        <div className="pricing-bg-pattern"></div>

        {/* Header */}
        <div className="pricing-header">
          <div className="pricing-eyebrow">
            <Sparkles size={14} />
            <span>Our Fleet</span>
            <Sparkles size={14} />
          </div>
          <h2>Choose Your <span>Perfect Ride</span></h2>
          <p>Select from our wide range of well-maintained vehicles for a comfortable and safe journey.</p>
        </div>

        {/* Pricing Grid */}
        <div className="pricing-grid">
          {vehicles.map((vehicle) => (
            <div className={`pricing-card ${vehicle.popular ? 'popular' : ''}`} key={vehicle.id}>
              {vehicle.popular && (
                <div className="pricing-badge">
                  <Award size={12} />
                  Most Popular
                </div>
              )}

              <div className="pricing-image-wrapper">
                <img src={vehicle.img} alt={vehicle.name} loading="lazy" />
                <div className="pricing-image-shimmer"></div>
                <div className="pricing-image-number">{String(vehicle.id).padStart(2, '0')}</div>
                <div className="pricing-image-tag">{vehicle.name}</div>
              </div>

              <div className="pricing-info">
                <h3>{vehicle.name}</h3>
                <p className="pricing-model">{vehicle.model}</p>
                <p className="pricing-rate">{vehicle.rate}</p>

                <div className="pricing-features">
                  <div className="pricing-feature">
                    <Users size={14} />
                    <span>{vehicle.seats}</span>
                  </div>
                  <div className="pricing-feature">
                    <Briefcase size={14} />
                    <span>{vehicle.bags}</span>
                  </div>
                  <div className="pricing-feature">
                    <Shield size={14} />
                    <span>{vehicle.ac}</span>
                  </div>
                </div>

                <button className="pricing-book-btn" onClick={handleBookNow}>
                  <span>Book Now</span>
                  <ArrowRight size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Strip */}
        <div className="pricing-trust">
          <div className="trust-item">
            <Clock size={16} />
            <span>24/7 Availability</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <Shield size={16} />
            <span>Insured Rides</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <Star size={16} fill="#D4AF37" stroke="#D4AF37" />
            <span>4.8 ★ Average</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <Users size={16} />
            <span>500+ Happy Riders</span>
          </div>
        </div>
      </section>

      {/* Booking Modal */}
      <BookingModal isOpen={showPopup} onClose={closePopup} />
    </>
  );
};

export default Pricing;